/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeRight = createReactComponent(
  "arrow-badge-right",
  "IconArrowBadgeRight",
  [["path", { d: "M13 7h-6l4 5l-4 5h6l4 -5z", key: "svg-0" }]]
);

export { IconArrowBadgeRight as default };
//# sourceMappingURL=IconArrowBadgeRight.js.map
